import standardAction from '../../../utilities/standard-action';
import ActionTypes from '../constants/action-types';
import { RootActionTypes } from '../../../stores/types';

export default function setReturnItems(
  orderItems: io.flow.v0.models.LocalizedLineItem[],
): RootActionTypes {
  return standardAction(ActionTypes.SET_RETURN_ITEMS, orderItems);
}
